import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative z-10 hidden xl:block" }
const _hoisted_2 = { class: "relative w-[600px] h-full" }
const _hoisted_3 = { class: "bg-gradient-to-br from-h-primary-500 to-h-primary-400 rounded-full w-[95%] h-0 pb-[95%] mx-auto relative shadow-2xl blob" }
const _hoisted_4 = { class: "absolute inset-0 flex items-center justify-center" }
const _hoisted_5 = { class: "bg-white w-[85%] h-[75%] rounded-xl shadow-2xl flex flex-col transform rotate-1 hover:rotate-0 transition-transform duration-500" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "h-8 bg-gray-100 rounded-t-xl flex items-center px-3 gap-1.5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "w-3 h-3 rounded-full bg-h-secondary-500" }),
  /*#__PURE__*/_createElementVNode("div", { class: "w-3 h-3 rounded-full bg-h-neutral-500" }),
  /*#__PURE__*/_createElementVNode("div", { class: "w-3 h-3 rounded-full bg-h-primary-500" })
], -1)
const _hoisted_7 = { class: "flex-grow bg-gray-50 flex items-center justify-center rounded-b-xl" }
const _hoisted_8 = { class: "group w-32 h-32 bg-gray-200 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-105" }
const _hoisted_9 = { class: "w-24 h-24 bg-h-primary-500 rounded-full flex items-center justify-center group-hover:bg-h-primary-500 transition-colors" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "absolute -bottom-6 -right-6 w-32 h-32 bg-gray-200 opacity-20 rounded-full" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_v_icon, {
                    name: "md-playarrow",
                    scale: 2.5,
                    class: "text-h-secondary-500"
                  }, null, 8, ["scale"])
                ])
              ])
            ])
          ])
        ]),
        _hoisted_10
      ])
    ])
  ]))
}